import React from 'react';
import { Link } from 'react-router-dom'
import { StyledEmptyList, EmptyText } from './styledComponents';

import Icon from 'components/Icon';
import Button from 'components/Button';

const EmptyList = ({ newChannelAction }) => (
  <StyledEmptyList>
    <Icon
      className='channel-list__empty-icon'
      size='140'
      name='channels'
    />
    <EmptyText>
      It’s looking empty around here…
    </EmptyText>
    <Link to='channels/new'>
      <Button>Make your first channel!</Button>
    </Link>
  </StyledEmptyList>
);

export default EmptyList;



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/ChannelList/EmptyList.js